import type { ITreeOptions } from '../model/ITreeOptions'
import type { ITreePerson } from '../model/ITreePerson'
import { expectDefined } from './expectDefined'
import { getCouples } from './getCouples'
import { getImageUrlForSvg } from './getImageUrlForSvg'

export async function makeTreePerson(
	options: ITreeOptions,
	personId: string,
	level = 0,
): Promise<ITreePerson> {
	try {
		const person = expectDefined(options.data.personsById[personId])
		const imageUrl = await getImageUrlForSvg(person, options)
		return {
			level: level,
			person: person,
			imageUrl: imageUrl,
			next: await Promise.all(
				getCouples(options.data, personId).map(
					async (it): Promise<ITreePerson> => {
						const spouseId = it.maleId === personId ? it.femaleId : it.maleId
						const spouse = spouseId
							? expectDefined(options.data.personsById[spouseId])
							: undefined
						const imageUrl = spouse
							? await getImageUrlForSvg(spouse, options)
							: undefined
						return {
							level: level,
							coupleWithPrevious: it,
							person: spouse,
							imageUrl: imageUrl,
							next: await Promise.all(
								it.childIds?.map(
									(id): Promise<ITreePerson> =>
										makeTreePerson(options, id, level + 1),
								) ?? [],
							),
						}
					},
				),
			),
		}
	} catch (e) {
		console.log(`[t9bf9c] Failing person:`, personId)
		throw e
	}
}
